import { CardContent, Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useGetUserContact } from "./hooks/useGetUserContact";
import { UserEmail } from "./UserEmail";
import { UserPassword } from "./UserPassword";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

export const MyDetails = () => {
    const { getUserDetails, getUserDetailsState, userDetails } = useGetUserContact();
    const { t } = useTranslation("profile");

    const fullName = userDetails ? `${userDetails.firstName} ${userDetails.lastName}` : "";

    return (
        <CardContent>
            <HandleErrorAndLoading
                error={getUserDetailsState.error}
                isLoading={getUserDetailsState.isLoading}
                retryFetch={getUserDetails}
            >
                <Grid container>
                    <Fragment>
                        <Grid className="mydetail__fields" container direction="column">
                            <Typography color="textSecondary" id="detailName" variant="small">
                                {t("name")}
                            </Typography>
                            <Typography aria-labelledby="detailName" variant="normal">
                                {fullName}
                            </Typography>
                        </Grid>
                        <UserEmail email={userDetails ? userDetails.email : ""} />
                        <UserPassword />
                    </Fragment>
                </Grid>
            </HandleErrorAndLoading>
        </CardContent>
    );
};
